export default {
  'ArtistGallerySection.title': { en: 'Gallery', fr: 'Galerie' },
  'ArtistGallerySection.editPhotos': {
    en: 'Edit Photos',
    fr: 'Modifier des photos',
  },
};
